import { getSelectedRange } from '../../common/utils/selection';
import { getBlockModelById, getContentModelByNode } from '../../common/utils/block';
import { events } from '../../common/constant';
export class MentionAction {
    constructor(manager) {
        this.parent = manager;
        this.wireEvents();
    }
    wireEvents() {
        this.parent.observer.on('mentionOpened', this.onMentionOpen, this);
        this.parent.observer.on(events.destroy, this.destroy, this);
    }
    unWireEvents() {
        this.parent.observer.off('mentionOpened', this.onMentionOpen);
        this.parent.observer.off(events.destroy, this.destroy);
    }
    onMentionOpen() {
        this.parent.nodeSelection.storeCurrentRange();
    }
    /**
     * Cleans the artifacts of mention control in BlockEditor such as mention chip and zero width space.
     *
     * @param {HTMLElement} element - specifies the element.
     * @param {boolean} isRemoveChip - specifies whether to remove the mention chip
     * @returns {void}
     * @hidden
     */
    cleanMentionArtifacts(element, isRemoveChip) {
        if (element) {
            const range = getSelectedRange();
            if (!range) {
                return;
            }
            const rangeParent = range.startContainer.nodeType === Node.TEXT_NODE
                ? range.startContainer.parentElement
                : range.startContainer;
            const insertedChip = rangeParent.querySelector('span[class="e-mention-chip"]');
            if (insertedChip && isRemoveChip) {
                insertedChip.remove();
            }
        }
    }
    /**
     * Removes the mention query keys from the block model.
     * When triggering command such as '/' or the filter queries, this function effectively cleans it in the block model
     *
     * @param {string} mentionChar - specifies the mention character.
     * @param {boolean} isUndoRedoAction - specifies whether the action is undo/redo action.
     * @returns {void}
     * @hidden
     */
    removeMentionQueryKeysFromModel(mentionChar, isUndoRedoAction) {
        const rangePath = this.parent.nodeSelection.getStoredBackupRange();
        if ((!rangePath || isUndoRedoAction) ||
            (rangePath && (!rangePath.startContainer || !rangePath.endContainer))) {
            return;
        }
        const { startContainer, startOffset, endOffset, contentElement } = rangePath;
        const blockEl = this.parent.currentFocusedBlock;
        const block = getBlockModelById(blockEl.id, this.parent.getEditorBlocks());
        const targetNode = document.contains(startContainer) ? startContainer : contentElement;
        if (!block || !block.content || block.content.length === 0) {
            return;
        }
        const affectedContent = getContentModelByNode(targetNode, this.parent.getEditorBlocks());
        if (!affectedContent || !affectedContent.content) {
            return;
        }
        const text = affectedContent.content;
        if (startOffset === endOffset) {
            let start = startOffset;
            while (start > 0 && text[start - 1] !== mentionChar) {
                start--;
            }
            // Adjust -1 to the start to remove the mention char as well.
            affectedContent.content = text.slice(0, start - 1) + text.slice(endOffset);
            // Remove contentchanged action triggered by typing '/'
            if (!isUndoRedoAction) {
                if (this.parent.undoRedoAction.undoRedoStack.length > 0) {
                    this.parent.undoRedoAction.undoRedoStack.pop();
                    this.parent.undoRedoAction.index = this.parent.undoRedoAction.undoRedoStack.length - 1;
                }
            }
        }
        this.parent.stateManager.updateManagerBlocks();
    }
    destroy() {
        this.unWireEvents();
    }
}
